import {call, put, takeLatest, fork, race, take, select} from 'redux-saga/effects'
import {actionTypes, actionCreators, selectors} from './search'
import fetchSiteSearch from '../../apis/site-search'
import {pushParam} from '../../utils'
import {requestTypes} from '../utils'
import {SEARCH_ERRORS} from '../../constants/errors'

const {
  LOAD_INITIAL_DATA, FETCH_SEARCH, UPDATE_SEARCH_QUERY, REQUEST_PAGE,
} = actionTypes

export function* loadInitialData() {
  const currentPage = yield select(selectors.getCurrentPage)
  yield updateCurrentPage({payload: currentPage})
}

export function* updateCurrentSearchResults({payload}) {
  const currentPage = yield select(selectors.getCurrentPage)
  // Push updated query to url
  yield call(pushParam, {q: payload})
  yield updatePageData(currentPage)
}

// handle request for new data on specific page.
export function* updatePageData(page) {
  const currentQuery = yield select(selectors.getQuery)
  yield fetchPageData(page, currentQuery)
}

// handle navigation between result pages
export function* updateCurrentPage({payload: page}) {
  const pageData = yield select(selectors.getPage(page))
  // if no data exists for the page, update the data
  if (!pageData || !pageData.results.length) {
    yield fork(updatePageData, page)
    const {failure} = yield race({
      success: take(FETCH_SEARCH[requestTypes.SUCCESS]),
      failure: take(FETCH_SEARCH[requestTypes.FAILURE]),
    })
    if (failure) {
      return
    }
  }
  
  // After fetching data check if the requested page is beyond the page count
  const pageCount = yield select(selectors.getPageCount)
  if (page !== 1 && page > pageCount) {
    // If page dosen't exist change to page 1
    yield updateCurrentPage({payload: 1})
    return
  }
  
  // Change to the new page
  yield call(pushParam, {page})
  yield call(window.scrollTo, 0, 0)
  yield put(actionCreators.changePage(page))
  
  // Preload data from next page
  const nextPageData = yield select(selectors.getPage(page + 1))
  if (!nextPageData) {
    yield* updatePageData(page + 1)
  }
}

export function* fetchPageData(page, query) {
  const pageSize = yield select(selectors.getResultsPerPage)
  yield put(actionCreators.fetchSearch.request(page, query))
  const {response, error} = yield call(fetchSiteSearch, {
    q: query,
    page,
    pageSize,
  })
  if (error) {
    yield put(actionCreators.fetchSearch.failure(page, SEARCH_ERRORS.API_ERROR))
  } else {
    yield put(actionCreators.fetchSearch.success(page, response))
  }
}

export default function* () {
  yield [
    fork(function* () {
      yield takeLatest(LOAD_INITIAL_DATA, loadInitialData)
    }),
    fork(function* () {
      yield takeLatest(UPDATE_SEARCH_QUERY, updateCurrentSearchResults)
    }),
    fork(function* () {
      yield takeLatest(REQUEST_PAGE, updateCurrentPage)
    }),
  ]
}



// WEBPACK FOOTER //
// ./src/store/actions/search-async.js